import { render, staticRenderFns } from "./EntrepreneurVideo.vue?vue&type=template&id=2cfb93f2&scoped=true&"
import script from "./EntrepreneurVideo.vue?vue&type=script&lang=js&"
export * from "./EntrepreneurVideo.vue?vue&type=script&lang=js&"
import style0 from "./EntrepreneurVideo.vue?vue&type=style&index=0&id=2cfb93f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfb93f2",
  null
  
)

export default component.exports